import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import { createTraining } from '../services/trainingsService';
import { FormattedMessage } from 'react-intl';
import Dialog from '../../../components/Dialog';
import TrainingForm from './TrainingForm';

// ----------------------------------------------------------------------

export default function NewUserDialog({ onClose, ...dialogProps }) {
  const { enqueueSnackbar } = useSnackbar();


  const handleTrainingCreate = async (values, actions) => {
    try {
      await createTraining(values);
      enqueueSnackbar(<FormattedMessage id='newTraining.create.msg.success' defaultMessage='Training successfully created' />, {
        variant: 'success',
      });
      onClose(true);
    } catch (error) {
      enqueueSnackbar(<FormattedMessage id='newTraining.create.msg.error' defaultMessage='Create training failed' />, {
        variant: 'error',
      });
      actions.setSubmitting(false);
    }
  };

  const handleClose = () => {
    onClose(false);
  };

  return (
    <Dialog
      {...dialogProps}
      onClose={handleClose}
      title={<FormattedMessage id='newTraining.title' defaultMessage='Create Training' />}
    >
      <TrainingForm
        onSubmit={handleTrainingCreate}
      />
    </Dialog>
  );
}

NewUserDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};
